import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/services/auth.service';
import { ITokenRequestData } from '../models/auth.interfaces';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuardService implements CanActivate {
  constructor(
    private _auth: AuthService,
    private _userService: UserService
  ) { }

  private adornKeyAndCodeFromStorage(
    tokenRequestData: ITokenRequestData
  ): ITokenRequestData {
    const loginKey = localStorage.getItem('Progreso.loginKey');

    if (typeof loginKey !== 'undefined' && loginKey) {
      tokenRequestData.loginKey = loginKey;
    }

    const securityCode = localStorage.getItem('Progreso.securityCode');

    if (typeof securityCode !== 'undefined' && securityCode) {
      tokenRequestData.securityCode = securityCode;
    }

    return tokenRequestData;
  }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this._auth.getToken().pipe(
      switchMap(() => {
        const authenticated = this._auth.isAuthenticated();
        if (authenticated) {
          return this._auth.isTwoFactorAuthenticationRequired().pipe(
            switchMap((r) => {
              if (r) {

                const logOffData: ITokenRequestData = {};

                this.adornKeyAndCodeFromStorage(logOffData);

                return this._userService.isTwoFactorAuthenticationGranted(logOffData);
              }
              else {
                return of(true);
              }
            })
          )
        };
        return from(of(authenticated));
      })
    );
  }
}
